<template>
  <form>

    <div class="md-layout">
      <div class="md-layout-item md-small-size-100">

        <md-card>
          <md-card-header class="md-card-header-icon" :class="getClass(headerColor)">
            <div class="card-icon">
              <md-icon>perm_identity</md-icon>
            </div>
            <h4 class="title">
              Edit Profile - <small>Complete your profile</small>
            </h4>
          </md-card-header>

          <md-card-content>
            <template v-for="(item, name) in formUi" >
              <md-checkbox
                v-if="item.type == 'checkbox'"
                v-model="form[name]"
                :key="name"
              >{{ item.label }}</md-checkbox><!-- :disabled="item.reportOnly" -->

              <md-field v-else :key="name" class="_uiKitInput">
                <label>{{ item.label }}</label>
                <md-input v-model="form[name]" :type="item.type" :key="name"></md-input>
              </md-field>
            </template>
          <!--
          The following were different wrappers being used before making page dynamic:
          <div class="md-layout-item md-small-size-100 md-size-50"></div>
          <div class="md-layout-item md-small-size-100 md-size-100"></div>
          <div class="md-layout-item md-small-size-100 md-size-33"></div>
          -->

          <div class="md-layout-item md-size-100 text-right">
            <md-button
              v-on:click="updateUser()"
              class="md-raised md-success mt-4"
              >Update Profile</md-button>
          </div>

      </md-card-content>
    </md-card>
    </div>
    </div>
    <div class="dynamicList-loading-spinner" v-show="promisePending">
      <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <md-snackbar
          :md-position="'center'"
          :md-duration="4000"
          :md-active.sync="snackbar.status"
          md-persistent
        >
          <span class="md-sm md-primary">
            {{snackbar.content}} &nbsp;
            <i class="md-icon md-icon-font md-bottom-bar-icon md-accent">{{snackbar.icon}}</i>
          </span>      
    </md-snackbar>
  </form>
</template>
<script>
import { Auth, API, graphqlOperation } from "aws-amplify";
import * as queries from '@/graphql/queries';
import * as mutations from '@/graphql/mutations';

export default {
  name: "edit-profile-form",
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      mapInputsIncons: {
        'email': 'account_circle',
        'username': 'account_circle',
        'password': 'lock_outline',
        'family_name': null,
        'given_name': 'face',
        // 'password2': null,
        // "authCode": "vpn_key"
      },
      form: {
        //name: null, // {string} The full name of the end-user, with optional language tag.
        given_name: null, // {string} The given or first name of the end-user, with optional language tag.
        family_name: null, // {string} The surname(s) or last name(s) of the end-user, with optional language tag.
        //middle_name: null, // {string} The middle name of the end-user, with optional language tag.
        nickname: null, // {string} The casual name of the end-user, with optional language tag.
        //preferred_username: null, // {string} The username by which the end-user wants to be referred to at the client application.
        //profile: null, // {string} The URL of the profile page for the end-user, with optional language tag.
        //picture: null, // {string} The URL of the profile picture for the end-user.
        website: null, // {string} The URL of the end-user's web page or blog.
        email: null, // {string} The end-user's preferred email address.
        email_verified: null, // {true|false} True if the end-user's email address has been verified, else false.
        //gender: null, // {"male"|"female"|?} The end-user's gender.
        //birthdate: null, // {string} The end-user's birthday, represented in ISO 8601:2004 YYYY-MM-DD format. The year may be 0000, indicating that it is omitted. To represent only the year, YYYY format is allowed.
        zoneinfo: null,  // should be "zoneinfo" but aws changed it {string} The end-user's time zone, e.g. Europe/Paris or America/Los_Angeles.
        locale: null, // {string} The end-user's locale, represented as a BCP47 language tag. This is typically an ISO 639-1 Alpha-2 language code in lowercase and an ISO 3166-1 Alpha-2 country code in uppercase, separated by a dash. For example, en-US or fr-CA.
        phone_number: null, // {string} The end-user's preferred telephone number, typically in E.164 format, for example +1 (425) 555-1212 or +56 (2) 687 2400.
        phone_number_verified: null, // {true|false} True if the end-user's telephone number has been verified, else false.
        address: {},// {object} A JSON object describing the end-user's preferred postal address with any of the following members:
          //formatted: null, // {string} The full mailing address, with multiple lines if necessary. Newlines can be represented either as a \r\n or as a \n.
          street_address: null, // {string} The street address component, which may include house number, street name, post office box, and other multi-line information. Newlines can be represented either as a \r\n or as a \n.
          locality: null, // {string} City or locality component.
          region: null, // {string} State, province, prefecture or region component.
          postal_code: null, // {string} Zip code or postal code component.
          country: null, // {string} Country name component.
        //}
      },
      formUi: {
        //name: null,
        given_name: {
          label: "First Name...",
          type: "text",
          slot: 'personal'
        },
        family_name: {
          label: "Last Name...",
          type: "text",
          slot: 'personal'
        },
        //middle_name: {},
        nickname: {
          label: "Nick Name...",
          type: "text",
          slot: 'personal'
        },
        //preferred_username: null,
        //profile: null,
        //picture: null,
        website: {
          label: "Website...",
          type: "text",
          slot: 'personal'
        },
        email: {
          label: "Email...",
          type: "email",
          required: true,
          slot: 'account'
        },
        email_verified: {
          label: "Email Verified",
          type: "checkbox",
          reportOnly: true,
          slot: 'account'
        },
        //gender: null,
        //birthdate: null,
        zoneinfo: { // should be "zoneinfo" but aws changed it
          label: "Timezone...",
          type: "email",
          slot: 'extra'
        },
        //locale: null,
        phone_number: {
          label: "Phone Number...",
          type: "email",
          slot: 'personal'
        },
        phone_number_verified: {
          label: "Phone Number Verified",
          type: "checkbox",
          reportOnly: true,
          slot: 'personal'
        },
        street_address: {
          label: "Street Address",
          type: "text",
          slot: 'address'
        },
        locality: {
          label: "City",
          type: "text",
          slot: 'address'
        },
        region: {
          label: "State",
          type: "text",
          slot: 'address'
        },
        postal_code: {
          label: "Postal Code",
          type: "text",
          slot: 'address'
        },
        country: {
          label: "Country",
          type: "text",
          slot: 'address'
        }
      },
      promisePending: false,
      snackbar: {
        'status': false,
        'content': "",
        'icon': "done"
      }
    };
  },
  async created() {
    this.$c.log("EditProfileForm.vue beforeCreate");

    this.$c.log("EditProfileForm.vue beforeCreate - fetching User attributes...");

    let attributes;
    this.$c.log("EditProfileForm.vue beforeCreate -  Auth.userAttributes()");
    await Auth.userAttributes(this.$Session.user)
    .then(data => {
      attributes = data;
    })
    .catch(() => this.$c.log("EditProfileForm.vue beforeCreate - ERROR fetching attributes!"));

    this.$c.log('EditProfileForm.vue beforeCreate - attributes=', attributes);

    attributes.forEach(function (value) {
      if (typeof this.form[value.Name] !== 'undefined') {
        // Address has nested members that need to be applied differently.
        if (value.Name === 'address') {
          let member, address = JSON.parse(value.Value);
          this.$c.log('EditProfileForm.vue beforeCreate - updating address...', address);

          for (member in address) {
            if (address.hasOwnProperty(member)) {
              this.form[member] = address[member];
            }
          }
        } else {
          let updatedValue = value.Value;
          // Amazon Cognito returns the booleans back as strings and they need to be boolean for v-model on checkbox to work
          if (["true", "false"].indexOf(updatedValue) !== -1) {
            updatedValue = JSON.parse(updatedValue);
          }
          this.form[value.Name] = updatedValue;
        }
      }
    }, this);

    this.$c.log('EditProfileForm.vue beforeCreate - form updated = ', this.form);
    this.$c.log("EditProfileForm.vue beforeCreate - done.");
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    async updateUser() {
      const {user} = this.$Session;
      let name, data = {address: {} };

      for (name in this.form) {
        if (this.form.hasOwnProperty(name)) {
          if (typeof this.formUi[name] !== 'undefined' && !this.formUi[name].reportOnly) {
            if (this.formUi[name].slot === 'address') {
              data.address[name] = this.form[name] === null ? "" : this.form[name];
            } else {
              data[name] = this.form[name] === null ? "" : this.form[name];
            }
          }
        }
      }

      data.address = JSON.stringify(data.address);

      this.$c.log("EditProfileForm.vue updating user with:", data);

      Auth.updateUserAttributes(user, data)
      .catch((e) => this.$c.log(e));
      
      this.promisePending = true;
      try {
        let ts = new Date().toISOString();
        let filter = {
          esQuery: JSON.stringify({"match": {"cogUsername": user.username }})
        };      
        let gqlSearchRequest = graphqlOperation(queries['searchUsers'], {filter});
        const mutateSearchResponse = await API.graphql(gqlSearchRequest);
        console.log("EditProfileForm.vue Search User successfully.", mutateSearchResponse);
        if(mutateSearchResponse.data.searchUsers.total == 1) {
          let userData = {
            id: mutateSearchResponse.data.searchUsers.items[0].id,
            given_name: data.given_name,
            family_name: data.family_name,
            updatedAt: ts
          };
          let gqlRequest = graphqlOperation( mutations['updateUser'], {input: userData});
          const mutateResponse = await API.graphql(gqlRequest);
          console.log("EditProfileForm.vue User updated successfully.", mutateResponse);
          this.promisePending = false;
          this.afterEditProfile(true);
        }else {
          this.promisePending = false;
          this.afterEditProfile(false);
        }
      } catch (error) {
        this.promisePending = false;
        this.afterEditProfile(false);
        console.log("EditProfileForm.vue Error--------------",JSON.stringify(error));
      }

    },
    afterEditProfile(success) {
      this.snackbar.status = true;
      this.snackbar.content = success ? "Profile updated successfully" : "Failed to update profile, please try again!";
      this.snackbar.icon = success ? 'done' : 'close';
    }
  }
};
</script>
<style></style>

/*

Should implement OpenId: https://connect2id.com/products/server/docs/api/userinfo
========
sub {string} The subject (end-user) identifier. This member is always present in a claims set.
[ name ] {string} The full name of the end-user, with optional language tag.
[ given_name ] {string} The given or first name of the end-user, with optional language tag.
[ family_name ] {string} The surname(s) or last name(s) of the end-user, with optional language tag.
[ middle_name ] {string} The middle name of the end-user, with optional language tag.
[ nickname ] {string} The casual name of the end-user, with optional language tag.
[ preferred_username ] {string} The username by which the end-user wants to be referred to at the client application.
[ profile ] {string} The URL of the profile page for the end-user, with optional language tag.
[ picture ] {string} The URL of the profile picture for the end-user.
[ website ] {string} The URL of the end-user's web page or blog.
[ email ] {string} The end-user's preferred email address.
[ email_verified ] {true|false} True if the end-user's email address has been verified, else false.
[ gender ] {"male"|"female"|?} The end-user's gender.
[ birthdate ] {string} The end-user's birthday, represented in ISO 8601:2004 YYYY-MM-DD format. The year may be 0000, indicating that it is omitted. To represent only the year, YYYY format is allowed.
[ zoneinfo ] {string} The end-user's time zone, e.g. Europe/Paris or America/Los_Angeles.
[ locale ] {string} The end-user's locale, represented as a BCP47 language tag. This is typically an ISO 639-1 Alpha-2 language code in lowercase and an ISO 3166-1 Alpha-2 country code in uppercase, separated by a dash. For example, en-US or fr-CA.
[ phone_number ] {string} The end-user's preferred telephone number, typically in E.164 format, for example +1 (425) 555-1212 or +56 (2) 687 2400.
[ phone_number_verified ] {true|false} True if the end-user's telephone number has been verified, else false.
[ address ] {object} A JSON object describing the end-user's preferred postal address with any of the following members:
[ formatted ] {string} The full mailing address, with multiple lines if necessary. Newlines can be represented either as a \r\n or as a \n.
[ street_address ] {string} The street address component, which may include house number, street name, post office box, and other multi-line information. Newlines can be represented either as a \r\n or as a \n.
[ locality ] {string} City or locality component.
[ region ] {string} State, province, prefecture or region component.
[ postal_code ] {string} Zip code or postal code component.
[ country ] {string} Country name component.
[ updated_at ] {number} Time the end-user's information was last updated, as number of seconds since the Unix epoch (1970-01-01T0:0:0Z) as measured in UTC until the date/time.
*/